import React from "react";
import PropTypes from "prop-types";
import QuizCardResult from "./QuizCard/QuizCardResult";
import {
  ANSWER_OPTION_LETTERS,
  QUIZ_ANSWER_STATES,
  QUIZ_RESULT_STATES
} from "./constants";
import ResultsPanel from "./ResultsPanel";

const propTypes = {
  attemptCount: PropTypes.number.isRequired,
  locked: PropTypes.bool.isRequired,
  lockedRedirectUrl: PropTypes.string,
  previousPercentCorrect: PropTypes.number,
  quizSubmission: PropTypes.shape({
    correct: PropTypes.number,
    incorrect: PropTypes.number,
    percentCorrect: PropTypes.number,
    quizQuestions: PropTypes.arrayOf(
      PropTypes.shape({
        answerOptions: PropTypes.arrayOf(
          PropTypes.shape({
            answerLetter: PropTypes.oneOf(ANSWER_OPTION_LETTERS).isRequired,
            answerText: PropTypes.string.isRequired,
            link: PropTypes.string,
            state: PropTypes.oneOf(Object.values(QUIZ_ANSWER_STATES)).isRequired
          })
        ),
        cardState: PropTypes.oneOf(Object.values(QUIZ_RESULT_STATES)),
        correctAnswerKey: PropTypes.oneOf(ANSWER_OPTION_LETTERS),
        id: PropTypes.number.isRequired,
        question: PropTypes.string
      })
    ),
    reviewLink: PropTypes.string,
    skipped: PropTypes.number
  }).isRequired
};

const defaultProps = {
  lockedRedirectUrl: null,
  previousPercentCorrect: null
};

function QuizResult({
  attemptCount,
  quizSubmission,
  locked,
  lockedRedirectUrl
}) {
  const { quizQuestions } = quizSubmission;

  const handleRetake = () => {
    if (locked) {
      // TODO: Future story to launch paywall, for now, redirect
      window.location.href = lockedRedirectUrl;
    } else {
      window.location.href = `${window.location.pathname}?retake=1`;
    }
  };

  const amplitudeEvent = locked
    ? "quizLockedRetakeButton"
    : "quizUnlockedRetakeButton";
  const amplitudeFunnel = locked ? "paid" : "none";

  return (
    <div>
      <div className="summary-section-quiz--summary">
        <ResultsPanel
          attemptCount={attemptCount}
          correct={quizSubmission.correct}
          incorrect={quizSubmission.incorrect}
          locked={locked}
          onRetakeClick={handleRetake}
          previousPercentCorrect={quizSubmission.previousPercentCorrect}
          reviewLink={quizSubmission.reviewLink}
          skipped={quizSubmission.skipped}
        />
      </div>
      <h4 className="quiz-questions-header title-6">Your Answers</h4>
      <div className="quiz-questions">
        {quizQuestions.map((quizQuestion, index) => {
          return (
            <QuizCardResult
              key={quizQuestion.id}
              answerOptions={quizQuestion.answerOptions}
              cardState={quizQuestion.cardState}
              questionId={quizQuestion.id}
              questionIndex={index + 1}
              questionText={quizQuestion.question}
            />
          );
        })}
      </div>
      <div className="summary-section-quiz--submit">
        <button
          className="btn btn-a-plus button-1 btn-lg"
          data-amplitude={amplitudeEvent}
          data-amplitude-funnel={amplitudeFunnel}
          data-testid="QuizSubmitButton"
          onClick={handleRetake}
          type="button"
        >
          {locked && <i className="lc-icon lc-icon-lock-filled lc-icon-sm" />}
          Retake Quiz
        </button>
      </div>
    </div>
  );
}

QuizResult.propTypes = propTypes;
QuizResult.defaultProps = defaultProps;

export default QuizResult;
